export const GET_RELEASE_DETAILS = 'get_release_details';
export const GET_RSS_SERVERS = 'get-rss-servers';
export const GET_RSS_SERVERS_Files = 'get-rss-servers-files';
export const GET_CLAIMED_SONGS = 'get-claimed-songs';
export const GET_SONGS_FOR_PITCHING = 'get-songs-for-pitching';
